/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-8c8a3203.js';
import { messageDefaultProps } from './defaultProps.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var globalConfig = {
  top: 32
};
var messageDefaultConfig = _objectSpread(_objectSpread({}, messageDefaultProps), {}, {
  duration: 3e3,
  placement: "top",
  zIndex: 5e3
});
var getMessageConfig = function getMessageConfig(options) {
  var currentOptions = _objectSpread({}, options);
  for (var i in currentOptions) {
    if (typeof currentOptions[i] === "undefined") {
      delete currentOptions[i];
    }
  }
  if (typeof currentOptions.duration !== "number" || currentOptions.duration < 0) {
    delete currentOptions.duration;
  }
  return _objectSpread(_objectSpread({}, messageDefaultConfig), currentOptions);
};
var setGlobalConfig = function setGlobalConfig(options) {
  messageDefaultConfig = _objectSpread({}, getMessageConfig(options));
};
var getMessageDefaultConfig = function getMessageDefaultConfig() {
  return _objectSpread({}, messageDefaultConfig);
};

export { getMessageConfig, getMessageDefaultConfig, globalConfig, setGlobalConfig };
//# sourceMappingURL=config.js.map
